import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'


import createSocketIOStorePlugin from '@/plugins/SocketIOStorePlugin'
import upperCaseFormatter        from '@/plugins/UpperCaseFormatterPlugin'
import responseChecker           from '@/plugins/ResponseCheckerPlugin'
import copyClipboard             from '@/plugins/CopyClipboardPlugin'



const token = localStorage.getItem('token')

if(token && store.state.user.isLoggedIn) {
  createSocketIOStorePlugin(token)
}



createApp(App).use(store).use(router).use(upperCaseFormatter).use(responseChecker).use(copyClipboard).mount('#app')


